export const RESOURCE_CATEGORIES = ["All", "Whitepaper", "Case Study", "eBook", "Webinar", "Blog"];

export const RESOURCES = [
  {
    id: "ai-roi-behavioral-science",
    title: "AI ROI Is a Behavioral Science Problem",
    description:
      "Why AI value hinges on human trust and behaviour change — told through Meera, a factory manager, and the one decision that makes or breaks ROI.",
    category: "eBook",
    cover: "/resources/ai-roi-behavioral-science.png",
    file: "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/81b9536a7c2523e6_AI_ROI_Story_Narrated.mp4",
    type: "video",
    cta: "Watch the story",
    meta: "Narrated film",
    date: "2026",
    featured: true,
  },
];
